import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { Field } from "redux-form";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { required, email } from "redux-form-validators";

import { Button, Input } from "../../../components/Field";
import Text from "../../../components/Text";
import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Editor from "../../../components/Editor";
import Section from "../../../components/Section";
import AsyncForm from "../../../components/AsyncForm";
import Background from "../../../components/Background";

import style from "./style.module.css";

export default function ForgotPassword(props) {
    const {
        title = "", 
        description = "", 
        bottom_text = "", 
        button_text ="" , 
        bg_image = ""
    } = props;
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [toEmail, setToEmail] = useState(null);
    const userProfile = useSelector((state) => state.storage.data);
    
    useEffect (() => {
        if(get(userProfile, 'id', null) !== null){
            navigate('/profile');
        }
        // eslint-disable-next-line
    } ,[])

    return (
        <Section className={style.signin}>
            <div className={style.signinWrapper}>
                <div className={style.signinBg}>
                    <Background src={bg_image} size="2560x1440"/>
                </div>
                {
                    step === 1 &&
                    <div className={style.formWrapper}>
                        <AsyncForm
                            url={`/account/forgot`}
                            permission={false}
                            showToastOnSuccess={false}
                            onSave={() => {
                                setStep(2)
                            }}
                            render={({ fetching, formValues }) => (
                                <div className={style.form}>
                                    <div className={style.formRow}>
                                        <div className={style.formHeader}>
                                            <div className={style.formTitleWrapper}>
                                                <Title className={style.formTitle} tag="h3">{title}</Title>
                                            </div>
                                            <div className={style.formDescription}>
                                                <Text text={description} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={style.formRow}>
                                        <Field 
                                            name="email" 
                                            component={Input} 
                                            validate={[required(), email()]} 
                                            placeholder="Enter your email" 
                                            label="Username"
                                            required={true}
                                        />
                                    </div>
                                    <div className={`${style.formRow} ${style.formSubmit}`}>
                                        <Button
                                            color="buttonPrimary"
                                            size="buttonFullWidth"
                                            submit={true}
                                            onClick={() => {
                                                setToEmail(formValues.email)
                                            }}
                                            fetching={fetching}
                                            label={button_text}
                                        />
                                    </div>
                                    <div className={`${style.formRow} ${style.formRowCol}`}>
                                        <Editor text={bottom_text} />
                                    </div>
                                </div>
                            )}
                        />
                    </div>
                }
                {
                    step === 2 &&
                    <div className={`${style.formWrapper} ${style.formWrapperCenter}`}>
                        <div className={style.formRow}>
                            <div className={style.formHeader}>
                                <div className={style.formTitleWrapper}>
                                    <Title align="center" className={style.formTitle} tag="h3">{title}</Title>
                                </div>
                                <div className={style.formDescription}>
                                    <Text text="Reset link has been sent to" />
                                    <Text className={style.email} text={toEmail} />
                                </div>
                            </div>
                        </div>
                        <div className={style.formRow}>
                            <Link className={style.link} to="/sign-in">Return to sign in page</Link>
                        </div>
                    </div>
                }
            </div>
        </Section>
    )
}